<div class="chart" *ngIf="positions && positions.length > 0">
<!--  <canvas baseChart class="chart-block"-->
<!--          [datasets]="barChartData"-->
<!--          [labels]="barChartLabels"-->
<!--          [options]="barChartOptions"-->
<!--          [plugins]="barChartPlugins"-->
<!--          [legend]="barChartLegend"-->
<!--          [chartType]="barChartType"-->
<!--          [colors]="barChartColors"-->
<!--          (chartClick)="chartClicked($event)">-->
<!--  </canvas>-->
</div>

<div *ngIf="!positions || positions.length === 0">
  No positions to show
</div>
